import { ThemeConfig } from '@naruto/naruto-theme/src/types';
import ThemeDefault from './default';

enum ThemeKey {
  DEFAULT = 'default'
}

const Themes: ThemeConfig = {
  [ThemeKey.DEFAULT]: ThemeDefault
};

export { ThemeKey as ThemeSTDKeys, Themes as ThemeSTDConfigs };
